(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/constants.js');
"use strict";

const menuItemsQs = {
  play: 'spela',
  about: 'om',
  system: 'systemspel',
  lottery: 'lottning'
};
const queryParam = 'flik';
setGlobal('svs.components.tipsen.gameGuideTipsen.constants', {
  menuItemsQs,
  queryParam
});

 })(window);